import React, { useState } from "react";
import { Button } from "../Button";
import { DropdownOptions } from "../dropdownOptions";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useAddSubject } from "../../hooks/subjectHooks/subject.hooks";
import { isEmpty } from "../../utils/array.utils";
import { SubjectForm } from "./SubjectForm";

export const AddSubject = () => {
  const dispatch = useDispatch();

  const [subjectName, setSubjectName] = useState("");
  const [selectedClasses, setSelectedClasses] = useState(
    [] as DropdownOptions[]
  );

  const [selectedSubjectTypeOption, setSelectedSubjectTypeOption] =
    useState<DropdownOptions | null>(null);

  const { isLoading: isAddingSubject, mutate: addSubject } = useAddSubject({
    onSuccess: () => {
      dispatch(setSuccessMessage("Subject added successfully."));
      setSubjectName("");
      setSelectedSubjectTypeOption(null);
      setSelectedClasses([]);
    },
    onError: (error: any) => {
      dispatch(
        setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
      );
    },
  });

  const onAddClass = () => {
    if (!subjectName) {
      return dispatch(setErrorMessage("Please provide subject name."));
    }
    if (!selectedSubjectTypeOption) {
      return dispatch(setErrorMessage("Please provide subject type."));
    }
    if (!selectedClasses || isEmpty(selectedClasses)) {
      return dispatch(setErrorMessage("Please select class."));
    }

    const classIds = selectedClasses
      .map((classItem) => classItem.value)
      .filter(Boolean);

    addSubject({
      name: subjectName,
      subject_type: selectedSubjectTypeOption?.value as string,
      classIds,
    });
  };

  const onClassSelected = (options: DropdownOptions[]) => {
    setSelectedClasses(options);
  };

  return (
    <div className="flex flex-col">
      <SubjectForm
        subjectName={subjectName}
        onSubjectNameChange={setSubjectName}
        subjectType={selectedSubjectTypeOption}
        onSubjectTypeChange={setSelectedSubjectTypeOption}
        selectedClass={selectedClasses}
        onClassChange={onClassSelected}
      />
      <div>
        <Button
          loading={isAddingSubject}
          text="Save"
          onClick={() => {
            onAddClass();
          }}
        />
      </div>
    </div>
  );
};
